import { React, Container, Helper, DataGrid, Pagination, TableColumns, DropDown } from "common";
import PopupDialog from "screens/popups";
import AgentImports from "helper/agentImports";
import { ImportApi, UsersApi } from "services";
import UploadFile from "helper/upload";

const formats = ["XLSX"];

const Component = (props) => {

    const [initlized, setInitlized] = React.useState(false);
    const [docInitlized, setDocInitlized] = React.useState(false);
    const [fileurl, setFileUrl] = React.useState(null);
    const [processing, setProcessing] = React.useState(null);
    const [formatError, setFormatError] = React.useState(null);
    const [validations, setValidations] = React.useState([]);
    const [importDocs, setImportDocs] = React.useState([]);
    const [importType, setImportType] = React.useState("");
    const [excelSchema, setExcelSchema] = React.useState({});
    const [agents, setAgents] = React.useState([]);
    const [agentId, setAgentId] = React.useState("");

    const [rowsCount, setRowsCount] = React.useState(0);
    const [curPage, setCurPage] = React.useState(1);
    const [pageSize] = React.useState(10);

    const OnOkClicked = (e) => {
        e.preventDefault();
        Helper.NativeInputClick("loanFile");
        setFormatError(null);
    }

    const OnFileSelected = async (e) => {
        e.preventDefault();
        setFileUrl(null);
        setValidations([]);
        let fileObj = e.target.files[0];
        if (!Helper.IsNullValue(fileObj)) {
            let _ext = fileObj.name.split(".").pop();
            let _index = formats.findIndex((x) => x === _ext.toUpperCase());
            if (_index > -1) {
                setFileUrl(e.target.files[0]);
            } else {
                setFormatError("Supported Format: " + formats.join(","));
            }
        }
    }

    const OnImportingStatus = (m, e) => {
        setProcessing(m);
        if (e) setValidations(e);
    }

    const OnUploadClicked = async (e) => {
        e.preventDefault();
        setValidations([]);
        global.Busy(true);

        let type = agents.find((x) => x._id === agentId)?.name;

        const importExcel = new AgentImports(type, fileurl, excelSchema, OnImportingStatus);

        let rslt = await importExcel.import();
        console.log(rslt);

        if (rslt.status !== 100) {
            global.Busy(false);
            if (rslt.statusText) setFormatError(rslt.statusText);
            return;
        }

        setProcessing(rslt.statusText);
        global.Busy(false);

        debugger;
        const res = rslt.data;
        let _res = res.trim().replace(/\s+/g, '');
        const dt = Helper.ToDateFormat(new Date(), "YYYYMMDDHHmmss");
        let _ext = fileurl.name.split(".").pop();
        const obj = { ext: _ext, ofileName: fileurl.name, nfileName: `${_res}_${dt}` };

        setProcessing("Uploading the selected file.");
        rslt = await UploadFile.Upload(fileurl, obj);

        if (rslt.status !== 100) {
            global.Busy(false);
            setProcessing(err.statusText);
            setFormatError(err.statusText);
            return;
        }

        const data = {
            type: "Agents",
            name: res,
            description: "Pending to process",
            agentId: agentId,
            statusId: 0,
            path: `${_res}_${dt}.${_ext}`
        };

        await ImportApi.SetImportDocs(data);

        global.Busy(false);
        setImportType("");
        Helper.NativeInputClick("loanFile");
        setProcessing("File upload to process.");
        setDocInitlized(true);
    }

    const buttons = [{ label: "Ok", event: OnOkClicked }];

    const FetchResults = async () => {
        global.Busy(true);
        let rslt = await ImportApi.GetExcelSChema();
        if (rslt.status === 100) {
            let _tmp = rslt.data || {};
            setExcelSchema(_tmp);
        }

        global.Busy(false);

        await GetPendingDocs();
    };

    const GetPendingDocs = async () => {
        global.Busy(true);
        let req = { page: curPage, size: pageSize, type: "Agents" };
        let rslt = await ImportApi.GetImportDocs(req);
        setImportDocs([]);
        setRowsCount(0);
        if (rslt.status === 100) {
            let tmp = rslt.data;
            setRowsCount(tmp.recordCount);
            setImportDocs(tmp.rows);
        }
        global.Busy(false);
    };

    const GetAgentList = async () => {
        let data = { page: 1, size: 99999, filters: { statusId: 1, typeId: 2 } }
        global.Busy(true);
        let rslt = await UsersApi.GetUsers(data);
        if (rslt.status === 100) {
            let _tmp = rslt.data.rows || [];
            setAgents(_tmp);
        }

        global.Busy(false);
    };

    if (initlized) {
        setInitlized(false);
        FetchResults();
        GetAgentList();
    }

    if (docInitlized) {
        setDocInitlized(false);
        GetPendingDocs();
    }

    React.useEffect(() => {
        setInitlized(true);
    }, []);

    const OnPageChange = async (e) => {
        setCurPage(e);
        setDocInitlized(true);
    }

    return (
        <Container {...props}>
            <div className="generic_headblk">
                <div className="blkName">{props.label}</div>
            </div>
            <div className="contentarea_table">
                <div className="control_bar2">
                    <div className="controlBarHeader">Agent Name:</div>
                    <div className="controlBarSelectField">
                        <select name="filterType" value={agentId} onChange={(e) => setAgentId(e.target.value)}>
                            <option value="">Select</option>
                            {agents.map((x) =>
                                <option key={x._id} value={x._id}>{x.name}</option>
                            )}
                        </select>
                    </div>
                    <div className="controlBarHeader">Excel File:</div>
                    <div className="controlBarTxtField">
                        <input type="file" id="loanFile" name="loanFile" accept=".xlsx"
                            onClick={(e) => { e.target.value = null; }}
                            autoComplete={Helper.TimeStamp()} onChange={(e) => OnFileSelected(e)} />
                    </div>
                    <div className="mcpl_nav_btn">
                        <input type="button" value="Upload" className="mcpl_btn" onClick={(e) => OnUploadClicked(e)} />
                    </div>
                    <div className="mcpl_nav_btn">
                        <input type="button" value="Download Sample" className="mcpl_btn" />
                    </div>
                </div>

                {validations && validations.length > 0 && (
                    <DataGrid dataColumns={TableColumns.AgentValidationColumns} pageSize={10}
                        rowsCount={validations.length} dataRows={validations} />
                )}
                {processing && (
                    <div className="mcplListTable">
                        <table>
                            <tbody>
                                <tr><td style={{ paddingLeft: 45, border: 0 }} >{processing}</td></tr>
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            <div className="contentarea_table" style={{ marginTop: 10 }}>

                <div className="control_bar" style={{ margin: 5 }}>
                    <div className="controlPagination">
                        {rowsCount > 0 &&
                            <Pagination onPageChange={OnPageChange} className="pagination-bar"
                                currentPage={curPage} rowsCount={rowsCount} pageSize={pageSize} />
                        }
                    </div>
                </div>

                {importDocs && importDocs.length > 0 ? (
                    <DataGrid dataColumns={TableColumns.AgentImportColumns}
                        curPage={curPage} onPageChange={OnPageChange} pageSize={pageSize}
                        rowsCount={rowsCount} dataRows={importDocs} />

                ) : (
                    <div className="mcplListTable">
                        <table>
                            <tbody>
                                <tr><td style={{ paddingLeft: 45, border: 0 }} >No pending documents found to process.</td></tr>
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            {formatError && (
                <PopupDialog id={"importPopup"} title={"Importing Loans"} buttons={buttons} width={450} >
                    <div className="contentarea_table" style={{ border: 0 }} id="importPopup">
                        {formatError}
                    </div>
                </PopupDialog>
            )}
        </Container>
    );
};

export default Component;